"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitValues = void 0;
class BitValues {
    constructor(val = 0) {
        this.val = val;
        this.getValue = () => this.val;
    }
    static create(...keys) {
        const bv = new BitValues();
        keys.forEach(value => bv.true(value));
        return bv;
    }
    isTrue(p) {
        return (this.val & (1 << p)) !== 0;
    }
    isFalse(p) {
        return !this.isTrue(p);
    }
    true(p) {
        this.val |= (1 << p);
        return this;
    }
    false(p) {
        this.val &= ~(1 << p);
        return this;
    }
    toggle(p) {
        this.val ^= (1 << p);
        return this;
    }
}
exports.BitValues = BitValues;
